import FormularioResponder from './FormularioResponder';

export default FormularioResponder;